import type { CSSProperties, Ref } from "react";

import { cn } from "@/components/ui/lib/utils";

import { SlashMenuItem } from "./slash-menu-item";
import type { SlashMenuItem as SlashMenuItemData } from "./slash-menu-types";

export type SlashMenuListProps = {
	items: SlashMenuItemData[];
	selectedIndex: number;
	onHover: (index: number) => void;
	onPick: (index: number) => void;
	floatingRef: Ref<HTMLDivElement>;
	floatingStyle: CSSProperties;
};

export function SlashMenuList({
	items,
	selectedIndex,
	onHover,
	onPick,
	floatingRef,
	floatingStyle,
}: SlashMenuListProps) {
	if (items.length === 0) {
		return (
			<div
				ref={floatingRef}
				style={floatingStyle}
				className={cn(
					"z-50 w-64 origin-(--transform-origin) overflow-x-hidden overflow-y-auto rounded-lg bg-popover p-1 text-popover-foreground shadow-md ring-1 ring-foreground/10 outline-none",
					"px-3 py-2 text-xs text-muted-foreground",
				)}
			>
				未找到匹配的技能
			</div>
		);
	}

	return (
		<div
			ref={floatingRef}
			style={floatingStyle}
			className={
				"z-50 w-64 origin-(--transform-origin) overflow-x-hidden overflow-y-auto rounded-lg bg-popover p-1 text-popover-foreground shadow-md ring-1 ring-foreground/10 outline-none"
			}
			data-testid="composer-slash-menu"
		>
			{items.map((item, index) => (
				<SlashMenuItem
					key={item.slug}
					item={item}
					selected={index === selectedIndex}
					onPick={() => onPick(index)}
					onHover={() => onHover(index)}
				/>
			))}
		</div>
	);
}
